import Api from '../Api'

export interface IUrlShortener {
  id: number
  title: string
  original_url: string
  short_path: string
  access_count: number
  period_clicks: number
  qr_code_url: string
}

export interface ICreateUrlShortenerPayload {
  title: string
  original_url: string
  short_path?: string
}

export interface IListResponse {
  data: IUrlShortener[]
  recordsTotal: number
  recordsFiltered: number
}

export interface IGetUrlShortenerResponse {
  id: number
  user_id: number
  title: string
  original_url: string
  short_path: string
  access_count: number
  created_at: string
  deleted_at: any
  clicks: IGetUrlShortenerClicks[]
}

export interface IGetUrlShortenerClicks {
  id: number
  url_shortener_id: number
  ip_address: string
  user_agent: string
  referrer: any
  country: string
  device_type: string
  browser: string
  os: string
  clicked_at: string
  created_at: string
  updated_at: string
}

const UrlShortenerService = {
  async list(search?: string, page?: number, pageSize?: number, from?: string, to?: string): Promise<IListResponse> {
    const params = {
      search: search || '',
      page: page || 1, // Default to page 1 if not provided
      page_size: pageSize || 10, // Default to 10 items per page if not provided,
      from: from || '',
      to: to || ''
    }
    const { data } = await Api.get('/url-shorteners', { params })
    return data
  },

  async get(id: number): Promise<IGetUrlShortenerResponse> {
    const { data } = await Api.get(`/url-shorteners/${id}`)
    return data
  },

  async create(payload: ICreateUrlShortenerPayload): Promise<IUrlShortener> {
    const { data } = await Api.post('/url-shorteners', payload)
    return data
  },

  async delete(id: number): Promise<void> {
    await Api.delete(`/url-shorteners/${id}`)
  },

  async update(id: number, payload: ICreateUrlShortenerPayload): Promise<IUrlShortener> {
    const { data } = await Api.put(`/url-shorteners/${id}`, payload)
    return data
  }
}

export default UrlShortenerService
